import Vue from 'vue'

const actions = {
    updateProgress: (context, payload) => {
        context.commit('UPDATE_PROGRESS', payload)
    },
}
const getters = {
    getAll: state => state,
}
const mutations = {
    UPDATE_PROGRESS: (state, payload) => {
        const lastUpdated = new Date()
        Vue.set(state, 'numProcessed', payload.numProcessed)
        Vue.set(state, 'numSuccessful', payload.numSuccessful)
        Vue.set(state, 'numError', payload.numError)
        Vue.set(state, 'isComplete', payload.isComplete)
        Vue.set(state, 'lastUpdate', lastUpdated)
        state.history.push({
            numProcessed: payload.numProcessed,
            numSuccessful: payload.numSuccessful,
            numError: payload.numError,
            isComplete: payload.isComplete,
            lastUpdate: lastUpdated,
        })
        if (state.history.length > 10) {
            state.history.shift();
        }
    },
}
const state = {
    numProcessed: undefined,
    numSuccessful: undefined,
    numError: undefined,
    isComplete: undefined,
    lastUpdate: undefined,
    history: [],
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
